//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AlgoliaEditorial from '@/scripts/libs/algolia/editorial'
import RbAlgoliaBaseEditorialProducts from '@/elements/editorial/algolia/rb-algolia-base-editorial-products.vue'
export default {
  name: 'rb-algolia-trending-items',
  components: {
    RbAlgoliaBaseEditorialProducts,
  },
  props: {
    dataElementId: {
      type: String,
      default: '',
    },
    facetName: {
      type: String,
      default: '',
    },
    facetValue: {
      type: String,
      default: '',
    },
    internalContent: {
      type: Boolean,
      default: false,
    },
    isCluster: {
      type: Boolean,
      default: true,
    },
    maxNumber: {
      type: Number,
      default: 10,
    },
    threshold: {
      type: Number,
      default: 50,
    },
    title: {
      type: String,
      default: '',
    },
    wishlistIconIsVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      initialized: false,
      products: [],
    }
  },
  computed: {
    isVisible() {
      return !this.initialized || (this.initialized && this.products.length > 0)
    },
  },
  methods: {
    async onViewportIntersection(e, isIntersecting) {
      if (!this.initialized && isIntersecting) {
        this.initialized = true
        this.products = await AlgoliaEditorial.getTrendingItems({
          facetName: this.facetName,
          facetValue: this.facetValue,
          isCluster: this.isCluster,
          maxNumber: this.maxNumber,
          threshold: this.threshold,
        })
      }
    },
  },
}
